module.exports = __webpack_public_path__ + "static/media/explainerGif2.45a5061f.gif";